import { originatesFromRemoteBackendAgent, type Transaction } from '@canvas/transaction';

interface GetBackendAgentEditedEntryIdsOptions {
  changedEntryIds: readonly string[];
  currentEntryIds: readonly string[];
  previousEntryIds: readonly string[];
  transaction: Transaction;
}

export function getBackendAgentEditedEntryIds({
  changedEntryIds,
  currentEntryIds,
  previousEntryIds,
  transaction
}: GetBackendAgentEditedEntryIdsOptions): readonly string[] {
  if (!originatesFromRemoteBackendAgent(transaction)) {
    return [];
  }

  const currentEntryIdSet = new Set(currentEntryIds);
  const previousEntryIdSet = new Set(previousEntryIds);

  return [...new Set(changedEntryIds)].filter(
    (entryId) => currentEntryIdSet.has(entryId) && previousEntryIdSet.has(entryId)
  );
}

export function getVisibleBackendAgentEditedEntryIds(
  editedEntryIds: readonly string[],
  visibleEntryIds: readonly string[]
): readonly string[] {
  const editedEntryIdSet = new Set(editedEntryIds);
  return visibleEntryIds.filter((entryId) => editedEntryIdSet.has(entryId));
}
